module.exports = __webpack_public_path__ + "static/media/popcorn-kaget.e03c0d73.png";